import React from "react";
import Box from "@mui/material/Box";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import PageTitle from "shared/ui/PageTitle";
import BoxContent from "shared/ui/BoxContent";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useRouteMatch } from "utils/functions";
import GenericButton from "../../../shared/ui/GenericButton";
import Users from "../components/Users";

const Students = () => {
    const { user, tenant } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const currentTab = useRouteMatch(["/elevi", "/elevi/arhiva"]);

    return (
        <Box>
            <PageTitle
                actions={
                    <GenericButton
                        type="add"
                        onClick={() => {
                            navigate(`/elevi/adauga`);
                        }}
                    />
                }
            >
                    Elevi
              </PageTitle>

            <BoxContent>
                <>
                    {/*{(user.position === "principal" || (tenant.type === "teacher" && user.position === "teacher")) && (*/}
                        <Box sx={{width: "100%"}}>
                            <Box mb={2} sx={{borderBottom: 1, borderColor: "divider"}}>
                                <Tabs
                                    value={currentTab}
                                    sx={{
                                        "& .MuiTabs-flexContainer": {
                                            flexWrap: "wrap",
                                        },
                                    }}
                                >
                                    <Tab label="Elevi activi" value="/elevi" to="/elevi" component={Link}/>
                                    <Tab
                                        label="Elevi arhivați"
                                        value="/elevi/arhiva"
                                        to="/elevi/arhiva"
                                        component={Link}
                                    />
                                </Tabs>
                            </Box>
                            {location.pathname === "/elevi" && <Users type="students" isArchived={false}/>}
                            {location.pathname === "/elevi/arhiva" && <Users type="students" isArchived={true}/>}
                        </Box>
                </>
            </BoxContent>
        </Box>
        );
};

export default Students;
